import {recalculateInnerPosition} from '../../helpers';
import {EnrichedAstNode} from '../../types';

export function removeResponsiveProperties(newGroup: EnrichedAstNode, preserveChildAlignment: boolean) {
    newGroup.children.forEach((node) => {
        removeChildResponsiveProperties(node, preserveChildAlignment);
    });

    delete newGroup.styles['alignItems'];
    delete newGroup.styles['justifyContent'];
    delete newGroup.styles['flexDirection'];
    delete newGroup.styles['display'];
    delete newGroup.styles['gap'];
    recalculateInnerPosition(newGroup);

    if (newGroup.userInput?.builderComplete) {
        return;
    }
}

function removeChildResponsiveProperties(node: EnrichedAstNode, preserveChildAlignment: boolean) {
    if (!preserveChildAlignment) {
        delete node.styles['alignSelf'];
        delete node.styles['position'];
        delete node.styles['top'];
        delete node.styles['left'];
    }

    ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'].forEach((margin) => {
        if (!node.calculatedLayoutAbstraction?.userMarginSet?.[margin]) {
            node.position[margin] = 0;
        }
    });

    delete node.styles['margin'];
    recalculateInnerPosition(node);
}
